import React from 'react'
import Layout from '../../../Layout'
import EditAdminContainer from '../../../../../Components/UserPart/EditUser/Admin/EditAdminContainer'

const EditAdmin = () => {
  return (
    <Layout><EditAdminContainer/></Layout>
  )
}

export default EditAdmin